<template>
  <div>
    <modal
      :name="modalName"
      :width="1000"
      :height="'auto'"
      :adaptive="true"
      :max-width="1200"
      :class="['u-text-align-center', 'role-selection-modal']"
      :resizable="true"
      @closed="hide">
      <div
        :key="renderKey"
        style="overflow: scroll; height: 65vh;"
        class="modal-container">
        <div class="dialog-header">
          {{ title }}
          <span
            style="float: right; width: 27px; height: 27px; margin-right: -27px; cursor: pointer;"
            class="close-button"
            @click="hide()">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.0303 8.96965C9.73741 8.67676 9.26253 8.67676 8.96964
       8.96965C8.67675 9.26255 8.67675 9.73742 8.96964 10.0303L10.9393
        12L8.96966 13.9697C8.67677 14.2625 8.67677 14.7374 8.96966
         15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12
          13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232
           15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303
            13.9696L13.0606 12L15.0303 10.0303C15.3232 9.73744 15.3232
             9.26257 15.0303 8.96968C14.7374 8.67678 14.2625 8.67678
              13.9696 8.96968L12 10.9393L10.0303 8.96965Z"
                fill="#ccc" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371
         6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75
          12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75
           6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25
            6.89137 21.25 12C21.25 17.1086 17.1086 21.25
             12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
                fill="#ccc" />
            </svg>
          </span>
        </div>
        <div class="dialog-body">
          <div class="search-box">
            <input
              v-model="searchKeyword"
              type="text"
              class="form-control"
              placeholder="役割を検索..."
              @input="filterRoles">
          </div>

          <div
            v-if="selectedRoles.length > 0"
            class="selected-roles">
            <div class="selected-roles__label">選択済み ({{ selectedRoles.length }}件)</div>
            <div class="selected-roles__chips">
              <span
                v-for="roleKey in selectedRoles"
                :key="`selected-${roleKey}`"
                class="role-chip">
                {{ getRoleLabel(roleKey) }}
                <span
                  class="role-chip__remove"
                  @click="toggleRole(roleKey)">×</span>
              </span>
            </div>
          </div>

          <div class="role-list">
            <label
              v-for="role in filteredRoles"
              :key="role.key"
              class="role-list__item">
              <input
                v-model="selectedRoles"
                type="checkbox"
                :value="role.key">
              <span class="role-list__checkbox">
                <span
                  class="c-btn__icon-check"
                  style="position: relative; left: 6px; top: 10px;"
                  :class="{ 'c-btn__icon-check--on': isSelected(role.key) }">
                </span>
              </span>
              <span class="role-list__label">
                {{ role.labels.ja }}
                <span class="role-list__label-en">({{ role.labels.en }})</span>
              </span>
            </label>
          </div>
        </div>
        <div class="dialog-footer c-btn-wrap">
          <a
            class="c-btn"
            href="#"
            @click.prevent="confirmSelection">
            登録する
            <span class="c-btn__icon-arrow"></span>
          </a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'RoleSelectionDialog',
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    modalName: {
      type: String,
      default: 'roleSelectionModal',
    },
    title: {
      type: String,
      default: '役割を選択',
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedRoles: [],
      searchKeyword: '',
      filteredRoles: [],
      renderKey: 0,
    }
  },
  watch: {
    isShown() {
      if (this.isShown) {
        this.renderKey += 1
        this.selectedRoles = [...this.selectedIds]
        this.searchKeyword = ''
        this.filterRoles()
        this.show()
      } else {
        this.hide()
      }
    },
  },
  mounted() {
    this.filteredRoles = this.roles
  },
  methods: {
    show() {
      this.$modal.show(this.modalName)
    },
    hide() {
      this.$modal.hide(this.modalName)
      this.$emit('close')
    },
    isSelected(roleKey) {
      return this.selectedRoles.includes(roleKey)
    },
    toggleRole(roleKey) {
      const index = this.selectedRoles.indexOf(roleKey)
      if (index === -1) {
        this.selectedRoles.push(roleKey)
      } else {
        this.selectedRoles.splice(index, 1)
      }
    },
    getRoleLabel(roleKey) {
      const role = this.roles.find(r => r.key === roleKey)
      return role ? role.labels.ja : roleKey
    },
    filterRoles() {
      if (!this.searchKeyword) {
        this.filteredRoles = this.roles
        return
      }

      const keyword = this.searchKeyword.toLowerCase()
      this.filteredRoles = this.roles.filter(role => role.labels.ja.toLowerCase().includes(keyword)
        || role.labels.en.toLowerCase().includes(keyword))
    },
    confirmSelection() {
      this.$emit('select', this.selectedRoles)
      this.hide()
    },
  },
}
</script>

<style scoped>
.dialog-header {
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
  padding: 0 40px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  position: relative;
}

@media screen and (min-width: 600px) {
  .dialog-header {
    margin-top: 12px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
  }
}

@media screen and (min-width: 896px) {
  .dialog-header {
    font-size: 20px;
  }
}

.dialog-body {
  text-align: center;
  vertical-align: middle;
  margin-top: 15px;
  padding: 0 10px;
  overflow-y: auto;
  flex: 1;
}

@media screen and (min-width: 600px) {
  .dialog-body {
    margin-top: 20px;
    padding: 0 20px;
  }
}

.dialog-footer {
  text-align: center;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
}

@media screen and (min-width: 600px) {
  .dialog-footer {
    flex-direction: row;
    justify-content: center;
    gap: 15px;
  }
}

.search-box {
  margin-bottom: 20px;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 10px;
}

@media screen and (min-width: 600px) {
  .search-box {
    padding: 0;
  }
}

.selected-roles {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  text-align: left;
}

.selected-roles__label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.selected-roles__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.role-chip {
  display: inline-flex;
  align-items: center;
  background-color: #1976d2;
  color: white;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 14px;
}

.role-chip__remove {
  margin-left: 6px;
  cursor: pointer;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  transition: background-color 0.2s;
}

.role-chip__remove:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.role-list {
  text-align: left;
  max-height: calc(65vh - 200px);
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
}

.role-list__item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.role-list__item:last-child {
  border-bottom: none;
}

.role-list__item:hover {
  background-color: #f8f9fa;
}

.role-list__item input[type="checkbox"] {
  display: none;
}

.role-list__checkbox {
  margin-right: 12px;
}

.role-list__label {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.role-list__label-en {
  color: #666;
  font-size: 12px;
  margin-left: 5px;
}

.c-btn__icon-check {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(/images/icon-check_off.png);
  background-size: contain;
}

.c-btn__icon-check--on {
  background-image: url(/images/icon-check_on.png);
}

.modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.role-selection-modal .dialog-body {
  flex: 1;
  overflow-y: auto;
}
</style>
